import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import { createContainer } from '@dbk-legacy/muster/react';
import DBKButton from '@dbk/ui-buttons';
import { values, isEqual } from 'lodash';
import NotificationItem from './notification-item';
import { LoadingCircle } from '../../../components/common/loading';
import Error from '../../../components/common/error';
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed';
import Text,{H1} from '@dbk/ui-text';

class NotificationSettings extends PureComponent {
  constructor(props) {
    super(props);

    const items = this.props.notifications.settings;
    this.props.notifications.getSettings();
    this.handleSavePress = this.handleSavePress.bind(this);

    this.state = {
      selectedStates: { ...items },
      showSaveButton: false,
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedStates: { ...nextProps.notifications.settings }
    })
  }

  propTypes = {
    notification: PropTypes.shape({
      settings: PropTypes.array
    })
  }

  defalutProps = {
    notification: {
      settings: []
    }
  }

  handleChange = (item, e) => {
    if(isEnterorSpaceKeyPressed(e)){
    const prevSettings = this.props.notifications.settings;
    const updatedOptions = [];
    const updatedSettings = values(this.state.selectedStates);
    updatedSettings.forEach((dataRow) => {
      const copy = Object.assign({}, dataRow);
      if (copy.alertType === item.alertType) {
        copy.value = item.value === "T" ? "F" : "T";
      }
      updatedOptions.push(copy);
    });

    const sameSettings = isEqual(prevSettings, updatedOptions);
    this.setState({
      selectedStates: updatedOptions,
      showSaveButton: sameSettings !== true,
    });
  }
  }

  handleSavePress() {
    const {
      changePage,
      i18n: { messages },
    } = this.props;
    this.props.notifications.saveSettings(this.state.selectedStates);
    changePage({ pathname: '/profile' }, true);
    alert(messages['app.profile.notification.saveSettingMsg']);
  }

  render() {
    const { i18n: { messages }, auth } = this.props;
    const { selectedStates, showSaveButton } = this.state;
    const items = values(selectedStates);

    return (
      <div className="row">
        <div className="columns small-12 large-12  profile-container">
          <div className="profile-container__title" id="title_notificationPage_notificationSetting_test">
            <H1 className="margin-top-1" tabIndex={0} id="title_notificationSetting_test">{messages['app.common.pageTitle.notificationSettings']}</H1>
          </div>
          <div tabIndex={0} className="margin-bottom-10" id="text_notificationPage_notificationSetting_test">
            <Text >{messages['app.profile.notification.headMsg']}</Text>
          </div>
          <div className="notification-settings settings-list">
            <div className="notification-settings__container">
              <NavigationList>
                {
                  items && items.map((item, index) => (

                    <NavigationListItem
                      role="none"
                      testID={"list_notificationSetting_test_"+ index}
                      hasArrow={false}
                      onKeyDown={(e) => !auth.settingsDisabled ? this.handleChange(item, e) : null}
                      onClick={() => !auth.settingsDisabled ? this.handleChange(item) : null}
                      tabIndex={-1}
                    >
                      <NotificationItem
                        item={item}
                        messages={messages}
                      />
                    </NavigationListItem>
                  ))
                }
              </NavigationList>
            </div>
          </div>
          {showSaveButton &&
            <div className="row margin-top-20">
              <div className="small-4 large-2 float-right">
                <DBKButton
                  testID="btn_notificationPage_save_notificationSetting_test"
                  fullWidth
                  size='large'
                  onPress={this.handleSavePress}
                  disabled={auth.settingsDisabled} 
                >
                  {messages['app.profile.notification.saveButton']}
                </DBKButton>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
};

export default createContainer({
  $renderError: () => <Error />,
  $renderLoading: () => <LoadingCircle isPage />,
  $queries: {
    notifications: {
      settings: true,
      getSettings: { $call: 'getSettings' },
      saveSettings: { $call: 'saveSettings' }
    },
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    auth: {
      settingsDisabled: true
    }
  },
})(NotificationSettings);
